// extracted by mini-css-extract-plugin
export default {"card":"style_card__w1P4J","card__top":"style_card__top__YBal7","card__bottom":"style_card__bottom__ilSOV","card__list--cols":"style_card__list--cols__zNv0e"};